module.exports = __webpack_public_path__ + "img/Recurso 4.3ac56b3d.png";